<template>
    <div class="container-fluid cart">
        <div class="row justify-content-center">
            <div class="col-md-12 px-0 mx-0">

                <TheLoaderComponent v-if="showLoader"></TheLoaderComponent>

                <div
                    class="d-flex flex-column mt-5 flex-md-row justify-content-md-between position-relative align-items-start align-items-md-center">
                    <h1 class="header-title">{{ breadcrumbs.createOrder }} </h1>
                    <div class="d-flex flex-column flex-md-row  btn-lg btn">
                    </div>
                </div>
                <div v-if=" basicModel.length > 0">
                    <div v-if="basicModel.length>0" class="basic_models row justify-content-md-between">
                        <div class="col-xl-8 col-lg-7 col-md-5 col-sm-12 basic_models-list__block">
                            <h3 class="mb-4 mb-lg-1">{{ blockTitle.model }}</h3>
                            <div class="d-flex show-model__block flex-wrap row">
                                <div class="product-item"
                                     v-for="(product,productIndex) in basicModel">

                                    <div class="item col-12  d-flex flex-column flex-lg-row justify-content-md-between model-block-in-cart"
                                         :class="{'border border-danger': errorColor === true}"
                                         :data-color="product.color" :data-type="product.type" :data-id="product.id">
                                        <div class="image">
                                            <video
                                                v-if="product.file_hash !== null && product.file_hash !== undefined"
                                                :src="product.dynamic_img"
                                                class="product-image box-shadow-1"
                                                @mouseleave="showOnHoverOut(product)"
                                                @error="showNoPhotoImage(product)"
                                                @click="show3dNewTab(product)"
                                                autoplay
                                                type="video/mp4"
                                                loop
                                                :class="{'d-none': product.mouseover === false}"
                                            ></video>
                                            <img
                                                v-if="product.img"
                                                :src="showImgModel(product)"
                                                @mouseover="showOnHoverBaseModel(product)"
                                                alt="model-img"
                                                :class="{'d-none': product.mouseover === true}"
                                            >
                                        </div>
                                        <div class="d-flex flex-column description_main-block w-100">
                                            <div class="description">
                                                <div class="d-flex justify-content-between">
                                                    <span>{{
                                                            lang === 'ar-sa' ? product.name['ar-sa'] : product.name['en']
                                                        }}</span>
                                                    <div class="buttons">
                                                        <span class="delete-btn"><i @click="deleteProduct($event,product)"
                                                                                    class="fa-regular fa-trash-can"></i></span>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-wrap info-material">
                                                    <p v-if="product.category"
                                                       class="col-12 px-0 mx-0 d-flex align-items-center js-category-cart-model">
                                                        {{ titles.category }} :
                                                        <span>{{
                                                                lang === 'ar-sa' ? (product.category[0].title['ar-sa']) : (product.category[0].title['en'])
                                                            }}</span>
                                                    </p>
                                                    <div class="printing-params">
                                                        <p v-if="product.material"
                                                           class="">
                                                            {{ titles.material }} : <span>{{ product.material }}</span>
                                                        </p>
                                                        <p v-if="product.infillPercentage"
                                                           class="">
                                                            Infill : <span>{{ product.infillPercentage * 20 }} %</span>
                                                        </p>
                                                        <p v-if="product.layerHeight"
                                                           class="">
                                                            Layer height : <span>{{
                                                                product.layerHeight / 10
                                                            }} mm</span></p>
                                                    </div>
                                                    <div v-if="product.customFields" class="col-12 custom-fields-in-cart">
                                                        <p class="col-12 px-0 mx-0 d-flex align-items-center"
                                                            v-if="product.customFields.field1">{{ product.customFields.field1.title }} : <span>{{ product.customFields.field1.value }}</span></p>
                                                        <p class="col-12 px-0 mx-0 d-flex align-items-center "
                                                            v-if="product.customFields.field2">{{ product.customFields.field2.title }} : <span v-if="product.customFields.field2.value"><strong>File Loaded</strong></span><span v-else>File Not Loaded</span></p>
                                                        <p class="col-12 px-0 mx-0 d-flex"
                                                            v-if="product.customFields.field3">{{ product.customFields.field3.title }} : <span v-if="product.customFields.field3.value">{{ product.customFields.field3.value.option }} +{{ product.customFields.field3.value.additional_price }}{{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }}</span></p>
                                                    </div>

                                                    <div v-if="product.color"
                                                       class="cart-color col-10 px-0 js-change-text-color my-4 mx-0 d-flex align-items-center dropdown"
                                                         >
                                                        <p>{{ titles.color }} :</p>
                                                        <a class="show-color dropdown-toggle px-0 text-decoration-none   js-dropdown navigation-footer"
                                                           :style="{'background-color': product.color}"
                                                           href="#" role="button"
                                                           data-bs-toggle="dropdown"
                                                           aria-expanded="false"
                                                           @click="toggleDropDownColors()"
                                                        ></a>

                                                        <ul class="dropdown-menu" v-if="dropDownColors">
                                                            <li v-for="color in product.colors"

                                                                v-model="productColor = color"
                                                                class="choose-color my-0"
                                                                :data-value="color"
                                                                :style="{'background-color': color}"
                                                                @click="chooseProductColor(product, color)"
                                                                ></li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-row w-100 flex-sm-row mt-auto justify-content-between ">
                                                <div class="d-flex w-100 align-items-center justify-content-between">
                                                    <div class="d-flex total-price__block">
                                                        <h2 class="total-price">{{ product.priceCalculate }}</h2>
                                                        <h2> {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h2>
                                                    </div>
                                                    <div class="quantity ">
                                                        <button class="minus-btn" @click="minusProduct($event,product)"
                                                                type="button" name="button">
                                                            <i class="fa-solid fa-minus"></i>
                                                        </button>
                                                        <input type="text" name="name" :value="product.count">
                                                        <input type="hidden" name="type" :value="product.type">
                                                        <button class="plus-btn" @click="plusProduct($event,product)"
                                                                type="button"
                                                                name="button">
                                                            <i class="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5 col-md-6 col-sm-12 basic_models-pay__block">
                            <div class="pay__block">
                                <h3>{{ this.titles.summary }}</h3>
                                <div class=" create-address-absolute"
                                     v-if="address.length === 0 || newAddress === true">
                                    <div class="d-flex ">
                                        <div class="col-12 create-address__cart-block bg-white">
                                            <form data-url="" class="form mt-3 js-cart-addresses-create"
                                                  method="post">
                                                <input type="hidden" name="id" value="">
                                                <div
                                                    class="d-flex flex-column form-group justify-content-between mb-3 w-100">
                                                    <div class="col-12 mt-3 form-group">
                                                        <label class="js-change-text-title">{{ this.titles.title }}</label>
                                                        <input required
                                                               type="text"
                                                               class=""
                                                               name="title"
                                                               value=""
                                                               v-model="title"
                                                               @input="checkAllFieldsFilled">
                                                        <span class="error-text" role="alert" style="color: red">
                                                                                                      <strong></strong>
                                                                                                      </span>
                                                    </div>

                                                    <div class="col-12 mt-3">
                                                        <label class="js-change-text-country">{{ this.titles.country }}</label>
                                                        <v-select :options="optionCountries"
                                                                  v-model="codeCountry"
                                                                  name="country_code"
                                                                  :clearable="false"
                                                                  required
                                                                  placeholder="Choose country"
                                                                  class="input js-select-country-code"
                                                                  @input="checkAllFieldsFilled">
                                                            <template #open-indicator="{ attributes }" #val>
                                                              <span
                                                                  v-bind="attributes">
                                                              <img
                                                                  class="select-img"
                                                                  src="/images/icons/vector.png"/>
                                                              </span>
                                                            </template>
                                                        </v-select>

                                                        <span class="invalid-feedback" role="alert">
                                                      <strong></strong>
                                                      </span>
                                                    </div>

                                                    <div class="col-12 mt-3 form-group">
                                                        <label class="js-change-text-city">{{ this.titles.city }}</label>
                                                        <input type="text"
                                                               required
                                                               class=""
                                                               name="city"
                                                               value=""
                                                               v-model="city"
                                                               @input="checkAllFieldsFilled"
                                                        >

                                                        <span class="error-text" role="alert" style="color: red">
                                                                                                      <strong></strong>
                                                                                                      </span>
                                                    </div>

                                                    <div class="col-12 mt-3 form-group">
                                                        <label class="js-change-text-street">{{ this.titles.street }}</label>
                                                        <input type="text"
                                                               required
                                                               class=""
                                                               name="street"
                                                               value=""
                                                               v-model="street"
                                                               @input="checkAllFieldsFilled">
                                                        <span class="error-text" role="alert" style="color: red">
                                                                                                      <strong></strong>
                                                                                                      </span>
                                                    </div>

                                                    <div class="col-12 mt-3 form-group">
                                                        <label
                                                            class="js-change-text-number">{{ this.titles.postalCode }}</label>
                                                        <input required
                                                               type="text"
                                                               class=""
                                                               name="number"
                                                               value=""
                                                               v-model="number"
                                                               @input="checkAllFieldsFilled">
                                                        <span class="error-text" role="alert" style="color: red">
                                                                                                      <strong></strong>
                                                                                                      </span>
                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>


                                <div class="row create-phone-absolute" v-if="phone==0">
                                    <div class="d-flex ">
                                        <div class="col-12 create-phone-block bg-white">
                                            <label class=" js-change-text-create-phone">
                                                {{ this.titles.addNewPhone }}</label>
                                            <form action="#" :class="{'col': phone}"
                                                  class="js-form-cart-send-phone ">
                                                <div class="form-group js-cart-phone-block col-12"
                                                     v-if="phone==0">
                                                    <input type="tel"  name="phone" value="" class="phone js-cart-phone required"
                                                           placeholder="Phone number is required">
                                                    <span class="error-text" role="alert" style="color: red"
                                                          v-if="errorPhoneNumber === true">{{
                                                            this.titles.errorPhoneNumber
                                                        }}</span>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <form action="#" :class="{'col': phone}"
                                      class="js-form-cart-send-phone mb-5">
                                    <div class="form-group  " :class="{'col-12 ': phone, }"
                                         v-if="address.length > 0 && newAddress === false">
                                        <label class="js-change-text-address">{{ titles.address }}</label>
                                        <v-select :options="optionAddress"
                                                  @input="getId($event)"
                                                  name="address_id"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :placeholder="titles.placeholderAddress"
                                                  class="input form-control form-select js-cart-address">
                                            <template #open-indicator="{ attributes }" #val>
                                                                    <span v-bind="attributes">
                                                                        <img class="select-img"
                                                                             src="/images/icons/vector.png"/>
                                                                    </span>
                                            </template>
                                        </v-select>
                                        <div class="add-new-address-in-cart d-flex justify-content-end mt-3">
                                          <p @click="newAddress = true">{{ titles.addNewAddress }}</p>
                                        </div>
                                        <span class="error-text" role="alert" style="color: red"
                                              v-if="errorAddress === true">{{
                                                titles.placeholderAddress
                                            }}</span>
                                        <input type="hidden" class="js-cart-email" name="email" v-model="email">
                                        <input type="hidden" class="js-cart-first-name" name="first_name"
                                               v-model="firstName">
                                        <input type="hidden" class="js-cart-last-name" name="last_name"
                                               v-model="lastName">
                                    </div>
                                </form>

                                <div class="full-price mb-5">
                                    <h4 class="d-flex justify-content-between"><span class="js-change-text-brood-price">{{ titles.broodPrice }}:</span>
                                        {{ Math.round((fullDiscount + fullPrice + fullOffer) * 100) / 100 }} {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h4>
                                    <h4 class="d-flex justify-content-between"><span class="js-change-text-discount">{{ titles.discount }}:</span>
                                        {{ fullDiscount }}
                                        {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h4>
                                    <h4 class="d-flex justify-content-between"><span class="js-change-text-offer">{{ titles.offer }}:</span>{{ fullOffer }}
                                        {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h4>
                                    <h4 class="d-flex justify-content-between"><span class="js-change-text-shipping">{{ titles.shipping }}:</span> {{
                                            shipping
                                        }}
                                        {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h4>
                                </div>
                                <div class="d-flex " :class="{'flex-row-reverse': phone}">
                                    <div class="w-100">
                                        <div class="d-flex justify-content-between">
                                                <h3 class="section-title js-change-text-have-promo-code">
                                                    {{
                                                        titles.havePromoCode
                                                    }}</h3>
                                                <div class="checkbox-discount">
                                                    <input type="checkbox" @change="usePromocod" v-model="checkUsePromocod"
                                                           id="checkbox"
                                                           name="checkbox"
                                                           class="custom-checkbox  js-use-promocode">
                                                    <label for="checkbox" class="js-change-text-check-promo-code h-100">{{
                                                            titles.usePromoCode
                                                        }}</label>
                                                </div>
                                            </div>
                                        <input id="promocode" name="promocode" type="text"
                                               :placeholder="titles.promoCode"
                                               v-model="codeBody"
                                               @input="usePromocod"
                                               :hidden=!checkUsePromocod
                                               :class="{'border-danger': errorBorder}"
                                               class="col-12 mb-4 margin-bottom-20 js-change-text-placeholder-promo-code js-promocode">
                                    </div>
                                </div>

                                <div class="full-price mt-4">
                                    <h4><span class="js-change-text-total-price">{{ titles.totalPrice }}</span>:
                                        {{ Math.round((fullPrice + shipping) * 100) / 100 }} {{ lang === 'ar-sa' ? 'ر.س' : 'SAR' }} </h4>
                                </div>
                                <div class="create__btn-block">
                                    <p class="js-notify-error-color" v-if="errorColor === true"><span
                                        class="text-danger">Choose color for model</span>
                                    </p>
                                    <div class="mt-4 w-100">
                                        <button
                                            @click="globalCreateOrder($event)"

                                            class="btn btn-purple h-auto js-change-text-pay js-change-text-create-order text-white js-create-order w-100">
                                            {{ titles.pay }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- if empty cart -->
                <div class="col-8 mx-auto" style="height: 42vh;" v-else>
                    <h1 class="text-center">You don't have a selected item yet.
                        Go to the <a href="/gallery" class="link-to-gallery">Gallery </a> to choose a model</h1>
                </div>
                <!-- end if empty cart -->
            </div>

        </div>
    </div>
</template>

<script type="application/javascript">
import TheLoaderComponent from "./TheLoaderComponent";
import {validation} from "../helpers/validation";
import {off} from "process";
import ModalModel3dPreviewComponent from "./ModalModel3dPreviewComponent.vue";

export default {
    components: {ModalModel3dPreviewComponent, TheLoaderComponent},
    name: "CardModelConfiguration",
    props: ['products', 'size', 'order', 'orderStatus'],
    data() {
        return {
            newAddress: false,
            title: '',
            street: '',
            city: '',
            number: '',
            dropDownColors: false,
            dataProducts: [],
            basicModel: [],
            clientModel: [],
            lang: window.currentLang,
            checkUsePromocod: false,
            disabledBtn: true,
            fullPrice: 0,
            mainDescription: '',
            fullPriceClientModel: 0,
            broodPrice: 0,
            broodPriceClientModel: 0,
            fullDiscount: 0,
            fullDiscountClientModel: 0,
            fullOffer: 0,
            fullOfferClientModel: 0,
            shipping: shipping,
            codeBody: '',
            errorBorder: false,
            address: address,
            phone: phone,
            optionAddress: [],
            countries: JSON.parse(localStorage.getItem('countries')),
            optionCountries: [],
            codeCountry: '',
            email: email.email,
            addressId: {val: 0},
            productColor: '',
            showAddress: false,
            showPhoneInput: false,
            errorColor: false,
            errorAddress: false,
            errorPhoneNumber: false,
            breadcrumbs: {
                home: 'Home',
                gallery: 'Gallery',
                createOrder: 'Create an order'
            },
            blockTitle: {
                client: 'Client Models',
                model: 'Models'
            },
            titles: {
                color: 'Color',
                category: 'Category',
                material: 'Material',
                totalPrice: 'Total price',
                havePromoCode: 'I have promo code',
                usePromoCode: 'Use promo code',
                promoCode: 'Promo code',
                placeholderAddress: 'Choose address',
                address: 'Address',
                pay: 'Pay',
                createOrder: 'Create order',
                broodPrice: 'Original price',
                discount: "Discount",
                shipping: "Shipping",
                offer: "Offer",
                addNewPhone: "Phone Number",
                addNewAddress: "Add New Address",
                title: 'Title',
                country: 'Country',
                city: 'City',
                street: 'Street',
                postalCode: 'Postal Code',
            }
        }
    },



    mounted() {
        let vm = this

        try {
            this.getProducts()
        } catch {
            vm.basicModel = []
        }

        this.address.forEach(item => {
            let obj = {
                val: item.id,
                label: item.title + ' / ' + item.street,

            }

            this.optionAddress.push(obj)
        })
        this.countries.forEach(item => {
            let obj = {
                val: item.code,
                label: item.name
            }
            this.optionCountries.push(obj)
        })
        this.refreshData()//needed to refresh discount and offer sums
        this.addSocketListner()
    },
    created() {
        document.addEventListener('click', this.closeMenu);
    },


    methods: {

        checkAllFieldsFilled() {
            return (
                this.$data.title !== "" &&
                this.$data.country !== "" &&
                this.$data.city !== "" &&
                this.$data.street !== "" &&
                this.$data.number !== ""

            );
        },
        toggleDropDownColors() {
          this.dropDownColors = !this.dropDownColors;
        },
        // addProductToCartWithColor(product, color) {
        //     const newProduct = { ...product };
        //
        //     newProduct.color = color;
        //
        //     this.basicModel.push(newProduct);
        //     this.toggleDropDownColors()
        //     this.totalPrice();
        // },
        addSocketListner() {
            // create listener of socket channel to refresh page if we have calculated data to this user
            let vm = this;
            //in app.js window.sub is created
            window.sub.on('publication', function (ctx) {
                    if (ctx.data.videoDynamicRendered) {
                    }
                    if (ctx.data.imageStaticRendered) {
                    }
                }
            )
        },
        showNoPhotoImage(product) {
            product.mouseover = false;
        },
        showImgModel(product) {
            return product.img;
        },
        showOnHoverBaseModel(product) {
            if (product.file_hash !== null) {
                product.mouseover = true;
            }
        },
        showOnHoverOut(product) {
            if (product.file_hash !== undefined) {
                product.mouseover = false;
            }
        },
        show3dNewTab(product) {
            event.preventDefault();
            var params = {
                modelIdentificator: product.file_hash + '_' + product.file_size + '_' + product.color.replace('#', ''),
            };
            var queryString = Object.keys(params).map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            }).join('&');
            var url = window.location.protocol
                + '//' + window.location.host
                + '/' + 'gallery/3d-preview/'
                + queryString;
            window.open(url, '_blank');
        },
        refreshData() {
            if (this.basicModel) {
                this.basicModel.forEach(product => {
                    this.changePrice(product)
                });
            }
        },
        changeContent() {
            if (window.currentLang === 'ar-sa') {
                this.lang = 'ar-sa'

                this.breadcrumbs.home = 'رئيسي'
                this.breadcrumbs.gallery = 'صالة عرض'
                this.breadcrumbs.createOrder = 'سلة التسوق'

                this.blockTitle.client = 'نماذج العميل'
                this.blockTitle.model = "الطلبات"

                this.titles.createOrder = 'إرسال الطلب'
                this.titles.color = 'لون'
                this.titles.category = 'فئة'
                this.titles.material = 'مادة'
                this.titles.totalPrice = 'السعر الكلي'
                this.titles.price = 'السعر'
                this.titles.havePromoCode = 'لدي رمز ترويجي'
                this.titles.usePromoCode = 'استخدم الرمز الترويجي'
                this.titles.promoCode = 'رمز ترويجي'
                this.titles.placeholderAddress = 'اختر العنوان'
                this.titles.address = 'عنوان'
                this.titles.pay = "الدفع"
                this.titles.broodPrice = "المجموع الفرعي"
                this.titles.discount = "الخصم"
                this.titles.offer = "العروض"
                this.titles.shipping = "الشحن"
                this.titles.summary = 'ملخص الطلب'

                this.titles.addNewAddress = "إضافة عنوان جديد"
                this.titles.addNewPhone = "إضافة رقم الهاتف"
                this.titles.title = "اسم العنوان"
                this.titles.country = "الدولة"
                this.titles.city = "المدينة"
                this.titles.street = "الحي/الشارع"
                this.titles.postalCode = "الرمز البريدي"
                this.titles.create = "إنشاء"
                this.titles.phone = "هاتف"
                this.titles.addPhone = "إضافة الهاتف"


            } else {
                this.lang = 'en'

                this.breadcrumbs.home = 'Home'
                this.breadcrumbs.gallery = 'Gallery'
                this.breadcrumbs.createOrder = 'Cart'

                this.blockTitle.client = 'Client Models'
                this.blockTitle.model = 'Models'

                this.titles.createOrder = 'Create order'
                this.titles.color = 'Color'
                this.titles.category = 'Category'
                this.titles.material = 'Material'
                this.titles.totalPrice = 'Total price'
                this.titles.price = 'Total price'
                this.titles.havePromoCode = 'I have promo code'
                this.titles.usePromoCode = 'Use promo code'
                this.titles.promoCode = 'Promo code'
                this.titles.placeholderAddress = 'Choose address'
                this.titles.address = 'Address'
                this.titles.pay = 'Pay'
                this.titles.broodPrice = 'Original price'
                this.titles.discount = "Discount"
                this.titles.offer = "Offer"
                this.titles.shipping = "Shipping"
                this.titles.addNewAddress = "Add New Address"
                this.titles.addNewPhone = "Phone Number"
                this.titles.title = "Title"
                this.titles.country = "Country"
                this.titles.city = "City"
                this.titles.street = "Street"
                this.titles.postalCode = "Postal Code"
                this.titles.create = "Create"
                this.titles.phone = "Phone"
                this.titles.addPhone = "Add phone"
                this.titles.summary = 'Order Summary'

            }
        },
        getId(e) {
            let vm = this
            vm.addressId = e

        },

        chooseProductColor(product,color) {
            product.color = color;
            this.toggleDropDownColors()
        },
        globalCreateOrder($event) {
            if(this.checkAllFieldsFilled() || address.length > 0) {
                let vm = this
                vm.disabledBtn = false
                if (address == 0 || this.newAddress === true) {
                    if (phone == 0) {
                        vm.addPhoneNumer($event)
                            .then(() => {
                                return vm.createAddress($event);
                            })
                            .then(() => {
                                return vm.createOrder();
                            })
                            .catch((error) => {
                                window.notify('ERROR. Try again.')
                            });
                    } else {
                        vm.createAddress($event)
                            .then(() => {

                                vm.createOrder();
                            });
                    }
                } else {
                    vm.createOrder();
                }

            } else {
                window.notify('You must fill every field', 'error');
            }
        },
        createOrder() {

            let vm = this
            let dataToAjax = []
            vm.basicModel.forEach(product => {
                let objData = {}
                let custom_fields = [];
                let description = [];

                description.push(product.description);

                if (product.customFields) {
                    if (product.customFields.field1) {
                        custom_fields.push({
                            title: product.customFields.field1.title ?? null,
                            value: product.customFields.field1.value ?? null
                        });
                    }
                    if (product.customFields.field2) {
                        custom_fields.push({
                            title: product.customFields.field2.title ?? null,
                            value: product.customFields.field2.value ?? null
                        });
                    }
                    if (product.customFields.field3) {
                        custom_fields.push({
                            title: product.customFields.field3.title ?? null,
                            value: product.customFields.field3.value ?? null
                        });
                    }
                }

                objData.custom_fields = custom_fields
                objData.model_id = product.id
                objData.count = product.count
                objData.type = product.type
                objData.color = product.color
                objData.sum = product.priceCalculate
                if (!product.color) {
                    vm.errorColorClientModels = true
                }

                dataToAjax.push(objData)

            })

            if (!vm.addressId.val) {
                vm.errorAddress = true
            }

            axios.post('/order', {
                order: dataToAjax,
                address_id: +vm.addressId.val,
                promocode: vm.codeBody,
            }).then(function (response) {
                localStorage.getItem('lang') === 'ar-sa' ? window.notify('تم إنشاء الطلب') : window.notify('Order created')
                localStorage.removeItem(`cart-basic-${userId}`)
                window.location.href = response.data
                localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.dataProducts))
                vm.disabledBtn = false
            }).catch(function (xhr) {
                vm.disabledBtn = false
                localStorage.getItem('lang') === 'ar-sa' ? window.notify('لم يتم إنشاء الطلب. الرجاء استبدال المنتج', 'error') : window.notify('Order not created. Try to replace the product', 'error')
            })
        },
        addPhoneNumer(e) {
            return new Promise((resolve, reject) => {
                this.showPhoneInput = false;
                e.preventDefault();
                const phone_num = document.querySelector('.js-cart-phone').value;

                // Валидация телефонного номера
                if (phone_num.length < 5) {
                    this.errorPhoneNumber = true;
                    this.phone = 0;
                    reject('Phone number validation failed');
                } else {
                    this.phone = phone_num;
                    let dataObj = {
                        email: this.email,
                        phone: this.phone
                    };


                    axios.post('/user/update', dataObj)
                        .then((response) => {
                            window.notify('Phone added');
                            resolve(response);
                        })
                        .catch((error) => {
                            this.errorPhoneNumber = false;
                            this.phone = 0;
                            window.notify('Phone not added', 'error');
                            reject(error); // Отклонение промиса
                        });
                }
            });
        },
        createAddress(e) {
            return new Promise((resolve, reject) => {
                let vm = this;
                e.preventDefault();
                let form = document.querySelector('.js-cart-addresses-create');
                let formData = new FormData(form);
                formData.append('country_code', vm.codeCountry.val);
                axios.post('/address', formData)
                    .then(function (response) {
                        vm.addressId = {
                            val: response.data.data.id
                        }
                        localStorage.setItem('open', JSON.stringify(true));
                        if (localStorage.getItem('lang') === 'ar-sa') {
                            response && window.notify('تم إنشاء العنوان')
                        } else {
                            response && window.notify('Address created')
                        }

                        resolve(response);
                    })
                    .catch(function (xhr) {
                        if (localStorage.getItem('lang') === 'ar-sa') {
                            window.notify('لم يتم إنشاء العنوان', 'error')
                        } else {
                            window.notify('Address not created', 'error')
                        }

                        let response = JSON.parse(xhr.responseText);
                        validation(form, response.errors, true);
                        reject(xhr);
                    });
            });
        },

        totalPrice() {
            let vm = this
            if (null !== vm.basicModel) {
                const totalPrice = vm.basicModel.reduce((acc, products_items, i, arr) => {
                    return acc + products_items.priceCalculate;
                }, 0);
                const totalOffer = vm.basicModel.reduce((acc, products_items, i, arr) => {
                    return acc + products_items.offerCalculate;
                }, 0);
                const totalBrood = vm.basicModel.reduce((acc, products_items, i, arr) => {
                    return acc + products_items.broodCalculate;
                }, 0);
                vm.fullOffer = Math.round(parseFloat(totalOffer) * 100) / 100 || 0;
                vm.broodPrice = Math.round(parseFloat(totalBrood) * 100) / 100;
                vm.fullPrice = Math.round(parseFloat(totalPrice) * 100) / 100;
            }
        },
        plusProduct(e, product) {
            let vm = this
            e.preventDefault();
            product.count += 1;
            product.priceCalculate = product.count * product.price
            const changeProduct = vm.basicModel.find((item) => item.id === product.id)

            localStorage.removeItem(`cart-basic-${userId}`)
            vm.basicModel && localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.basicModel));
            this.changePrice(product)
            updateCartCount();
        },
        minusProduct(e, product) {
            let vm = this
            e.preventDefault();
            if (product.count > 1) {
                product.count -= 1;
            }
            product.priceCalculate = product.count * product.price
            const changeProduct = vm.basicModel.find((item) => item.id === product.id)

            localStorage.removeItem(`cart-basic-${userId}`)
            vm.basicModel && localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.basicModel));
            this.changePrice(product)
            updateCartCount();
        },

        usePromocod() {
            let vm = this
            let code = this.codeBody;
            if (this.checkUsePromocod === true && code.length < 4) {
                this.disabledBtn = true
            } else {
                this.disabledBtn = false
            }

            if (this.checkUsePromocod === true && code.length > 4) {
                this.usePromocode(code)
            }
            // clear promo if checkbox is unset
            if (this.checkUsePromocod === false) {
                this.codeBody = '';
                vm.fullDiscount = 0;
                vm.fullDiscountClientModel = 0;
            }
            vm.totalPrice()
        },
        usePromocode(code) {
            let vm = this

            axios.get(`/discount/${code}`).then(function (response) {
                let price = vm.fullPrice
                let clientPrice = vm.fullPriceClientModel

                let data = response.data.data
                if (data !== undefined) {
                    if (data.discount_type === 1) {
                        let newPrice = +price - (+price / 100 * response.data.data.discount)
                        let newPriceClientModel = +clientPrice - (+clientPrice / 100 * response.data.data.discount)

                        vm.fullDiscount = Math.floor(+price / 100 * response.data.data.discount)
                        vm.fullDiscountClientModel = Math.floor(+clientPrice / 100 * response.data.data.discount)

                        vm.fullPrice = Math.floor(newPrice * 100) / 100
                        vm.fullPriceClientModel = Math.floor(newPriceClientModel * 100) / 100


                    } else if (response.data.data.discount_type === 0) {
                        let newPrice = +price - response.data.data.discount
                        let newPriceClientModel = +clientPrice - response.data.data.discount

                        vm.fullDiscount = response.data.data.discount
                        vm.fullDiscountClientModel = response.data.data.discount

                        vm.fullPrice = Math.floor(newPrice * 100) / 100
                        vm.fullDiscountClientModel = Math.floor(newPriceClientModel * 100) / 100
                    }
                    vm.errorBorder = false
                } else {
                    vm.errorBorder = true
                }
            })
        },
        getProducts() {

            let vm = this
            let dataCartZero = JSON.parse(localStorage.getItem(`cart-basic-0`))
            vm.basicModel = JSON.parse(localStorage.getItem(`cart-basic-${userId}`)) !== null ? JSON.parse(localStorage.getItem(`cart-basic-${userId}`)) : []
            let clientModel = JSON.parse(localStorage.getItem(`cart-client-${userId}`)) !== null ? JSON.parse(localStorage.getItem(`cart-client-${userId}`)) : []
            // move custom models in basic cart array
            clientModel.forEach(productInClienArray => {
                let flagInCartSelectedColor = false;
                vm.basicModel.forEach((productInCart) => {
                    if (productInCart.type !== 'App\\Models\\Model\\Model'
                        && productInCart.color === productInClienArray.color
                        && productInCart.price === productInClienArray.price
                        && productInCart.name === productInClienArray.name
                        && productInCart.fileHash === productInClienArray.fileHash
                        && productInCart.fileSize === productInClienArray.fileSize
                        && productInCart.material === productInClienArray.material
                        && productInCart.infillPercentage === productInClienArray.infillPercentage
                        && productInCart.layerHeight === productInClienArray.layerHeight
                        && productInCart.type === productInClienArray.type) {

                        productInCart.count += productInClienArray.count;
                        productInCart.priceCalculate = productInCart.price * productInCart.count;

                        flagInCartSelectedColor = true;
                    }
                });
                if (!flagInCartSelectedColor) {
                    vm.basicModel.push(productInClienArray);
                }


            });
            // remove custom  array
            localStorage.removeItem(`cart-client-${userId}`);
            // move not logged models in basic cart array
            if (userId !== 0 && dataCartZero) {
                dataCartZero.forEach(productInNotLoggetCart => {
                    let flagInCartSelectedColor = false;
                    vm.basicModel.forEach((productInCart) => {
                        if (productInCart.id === productInNotLoggetCart.id && productInCart.color === productInNotLoggetCart.color) {
                            productInCart.count += productInNotLoggetCart.count;
                            productInCart.priceCalculate = productInCart.price * productInCart.count;
                            flagInCartSelectedColor = true;
                        }
                    });
                    if (!flagInCartSelectedColor) {
                        vm.basicModel.push(productInNotLoggetCart)
                    }
                });
                localStorage.removeItem(`cart-basic-0`)
            }
            localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.basicModel))
            this.totalPrice()
        },
        deleteProduct(e, product) {
            let vm = this
            for (var i = 0; i < vm.basicModel.length; i++) {
                if (vm.basicModel[i].color == product.color && vm.basicModel[i].id == product.id) {
                    vm.basicModel.splice(i, 1);
                }
            }
            localStorage.removeItem(`cart-${userId}`)
            vm.basicModel && localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.basicModel));
            if (vm.basicModel.length == 0) {
                let section = document.querySelector('.basic_models');
                if (section) {
                    section.remove();
                }
            }
            vm.totalPrice()
            updateCartCount();
        },
        changePrice(product) {
            let vm = this
            axios.get(`/offers`).then(function (response) {
                let offers = response.data.data

                if (offers) {
                    let discountOffer = offers.filter(offer => {
                        return product.count >= offer.number
                    })
                    discountOffer && discountOffer.slice(-1)
                    let offer = ((+product.price * +product.count) / 100 * (discountOffer.length && discountOffer[discountOffer.length - 1].discount))
                    offer = offer || 0
                    product.offerCalculate = (Math.floor(offer * 100) / 100);

                    let offerPrice = ((+product.price * +product.count) - (+product.price * +product.count) / 100 * (discountOffer.length && discountOffer[discountOffer.length - 1].discount))
                    product.priceCalculate = (Math.floor(offerPrice * 100) / 100)

                    product.broodCalculate = product.price * product.count

                    localStorage.removeItem(`cart-basic-${userId}`)
                    localStorage.setItem(`cart-basic-${userId}`, JSON.stringify(vm.basicModel));
                    vm.checkUsePromocod = false
                    vm.totalPrice()
                }
            });
        }
    },
    updated() {
        let vm = this
        let liLang = document.querySelectorAll('.js-change-lang li')
        this.changeContent()
    },
    beforeDestroy() {
        // remove event listener when component is destroyed
        document.removeEventListener('click', this.closeMenu);
    },

}
</script>

<style lang="scss">
@import "../../sass/front/cart";

.product-image {
    cursor: pointer;
}
.custom-fields-in-cart {
    span {
        padding: 0 1rem !important;
        margin: 0 !important;
        margin-left: 1rem !important;
        font-weight: 600 !important;
       background-color: $light-purple-darker;
        border-radius: 8px;

    }
    p:not(:last-child) {
        margin-bottom: 1rem;
    }
}
.printing-params {
    display: flex;
    flex-direction: column;

    p {
        display: flex;

        span {
            margin-top: 0 !important;
        }
    }
}

.pay__block {
    height: auto;
}

@media screen and (max-width: 992px) {
    div.image video {
        height: 27.1rem;
        width: 100%;
    }
    .client_models {
        display: flex;
        flex-direction: column;

    }
    .client_models-list__block {
        width: 100% !important;
        margin-bottom: 20px;
    }

    .basic_models-pay__block {
        width: 100% !important;
    }
    .client_models-pay__block {
        width: 100% !important;
    }
    .basic_models-list__block {
        width: 100% !important;
        margin-bottom: 20px;

    }
    .basic_models {
        display: flex;
        flex-direction: column;
    }
}

@media screen and (max-width: 768px) {
}
</style>
